module.exports = __webpack_public_path__ + "site/img/team_member_sign_陳柏彥.15a02bde.png";